// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mqk8d7BIMtMu33qcv91C{display:flex;align-items:center;justify-content:flex-end;gap:8px;padding-right:8px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/TableNew/ui/TableRowHead/HeaderRightContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,wBAAA,CACA,OAAA,CACA,iBAAA","sourcesContent":[".wrap {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Mqk8d7BIMtMu33qcv91C`
};
export default ___CSS_LOADER_EXPORT___;
